import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from 'store'
import PatientMessage from 'model/PatientMessage'
import PatientMessagesRepository from 'clients/db/PatientMessagesRepository'
import PatientMessagePage from 'model/PatientMessagePage'

interface PatientMessagesState {
  patientMessages: PatientMessage[]
  PatientMessagesPages: PatientMessagePage[]
  isLoading: boolean
}

const initialPatientMessagesState = {
  patientMessages: [] as PatientMessage[],
  PatientMessagesPages: [] as PatientMessagePage[],
  isLoading: false,
}

function startLoading(state: PatientMessagesState) {
  state.isLoading = true
}

const patientMessagesSlice = createSlice({
  name: 'patientMessages',
  initialState: initialPatientMessagesState,
  reducers: {
    fetchPatientMessagesStart: startLoading,
    fetchPatientMessagesSuccess: (state, { payload }: PayloadAction<PatientMessage[]>) => {
      state.isLoading = false
      state.patientMessages = payload
    },
    fetchPatientMessagesFirstPageSuccess: (
      state,
      { payload }: PayloadAction<PatientMessagePage>,
    ) => {
      state.isLoading = false
      state.PatientMessagesPages = [payload]
    },
    fetchPatientMessagesPageSuccess: (state, { payload }: PayloadAction<PatientMessagePage>) => {
      state.isLoading = false
      state.PatientMessagesPages = [payload, ...state.PatientMessagesPages]
    },
    clearMessagesSuccess(state) {
      state.PatientMessagesPages = []
    },
  },
})

export const {
  fetchPatientMessagesStart,
  fetchPatientMessagesSuccess,
  fetchPatientMessagesFirstPageSuccess,
  fetchPatientMessagesPageSuccess,
  clearMessagesSuccess,
} = patientMessagesSlice.actions

export const fetchAppointmentMessages = (
  patientId: string,
  limit: number,
  bookmark: any,
  doctorType?: string,
  userId?: any,
  showAllPatientsMessages?: boolean,
): AppThunk => async dispatch => {
  dispatch(fetchPatientMessagesStart())

  const patientMessages = await PatientMessagesRepository.searchAppointmentMessages(
    patientId,
    limit,
    bookmark,
    doctorType,
    userId,
    showAllPatientsMessages,
  )

  if (bookmark === 0) {
    dispatch(fetchPatientMessagesFirstPageSuccess(patientMessages))
  } else {
    dispatch(fetchPatientMessagesPageSuccess(patientMessages))
  }
}

export const clearMessages = (): AppThunk => async dispatch => {
  dispatch(clearMessagesSuccess())
}

export default patientMessagesSlice.reducer
